/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespTradeOnApprovalPromoTile_viewer = {|
  +onApprovalEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespTradeOnApprovalPromoTile_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "onApprovalEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "onApprovalEnabled",
          "type": "String!"
        }
      ],
      "name": "isEnabled",
      "storageKey": "isEnabled{\"key\":\"onApprovalEnabled\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
